import { config } from './api';

export const deletePaymentInstrument = async (authToken: string, companyID: number): Promise<void> => {
  const res = await fetch(`${config.url}/company/${companyID}/paymentInstrument`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + authToken,
    },
    method: 'delete',
  });

  if (res.ok) {
    const body = await res.json();
    return body.result;
  } else {
    throw new Error(`Request failed: ${res.status} ${res.statusText}`);
  }
}
